import CheckoutAddress from '@components/quiz_v2/QuizCheckout/components/CheckoutAddress/CheckoutAddress.vue';
import CheckoutInfo from '@components/quiz_v2/QuizCheckout/components/CheckoutInfo/CheckoutInfo.vue';
import CheckoutPayment from '@components/quiz_v2/QuizCheckout/components/CheckoutPayment/CheckoutPayment.vue';
import CheckoutPromo from '@components/quiz_v2/QuizCheckout/components/CheckoutPromo/CheckoutPromo.vue';
import CheckoutReviews from '@components/quiz_v2/QuizCheckout/components/CheckoutReviews/CheckoutReviews.vue';
import CheckoutWelcome from '@components/quiz_v2/QuizCheckout/components/CheckoutWelcome/CheckoutWelcome.vue';
import WeightLossPlans from '@components/quiz_v2/QuizCheckout/components/WeightLossPlans/WeightLossPlans.vue';
import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

export const useCheckoutProgressStore = defineStore('checkout-progress', () => {
  const steps = [
    CheckoutWelcome,
    CheckoutPromo,
    CheckoutInfo,
    CheckoutReviews,
    WeightLossPlans,
    CheckoutAddress,
    CheckoutPayment,
  ];

  const currentStepIndex = ref(0);
  const currentStep = computed(() => steps[currentStepIndex.value]);

  return {
    steps,
    currentStepIndex,
    currentStep,
  };
});
